const MobileSideBar=({data,shownData,time})=>{
    const [moon,pressure,sunrise,sunset,wind,hydrometer] = data
    return(
        
<div className="shadow-lg rounded-xl w-full md:w-60 p-4 bg-cusLightBlack  relative overflow-hidden md:hidden block">

    <div className="grid grid-cols-3 gap-4">
        <div className="flex flex-col items-center">
            <div className="relative">
                <div className="block relative">
                    <img alt="profil" src={sunrise} className="mx-auto object-cover rounded-full h-10 w-10 "/>
                </div>
             
            </div>
            <span className="text-gray-600 dark:text-gray-400 text-xs mt-2">
                {shownData.sunrise}
            </span>
        </div>
        <div className="flex flex-col items-center">
            <div className="relative">
                <div  className="block relative">
                    <img alt="profil" src={sunset} className="mx-auto object-cover rounded-full h-10 w-10 "/>
                </div>
             
            </div>
            <span className="text-gray-600 dark:text-gray-400 text-xs mt-2">
                {shownData.sunset}
            </span>
        </div>
        <div className="flex flex-col items-center">
            <div className="relative">
                <div  className="block relative">
                    <img alt="profil" src={moon} className="mx-auto object-cover rounded-full h-10 w-10 "/>
                </div>
             
            </div>
            <span className="text-gray-600 dark:text-gray-400 text-xs mt-2">
                {time}
            </span>
        </div>
        <div className="flex flex-col items-center">
            <div className="relative">
                <div className="block relative">
                    <img alt="profil" src={pressure} className="mx-auto object-cover rounded-full h-10 w-10 "/>
                </div>
             
            </div>
            <span className="text-gray-600 dark:text-gray-400 text-xs mt-2">
                {shownData.pressure}
            </span>
        </div>
        <div className="flex flex-col items-center">
            <div className="relative">
                <div className="block relative">
                    <img alt="profil" src={wind} className="mx-auto object-cover rounded-full h-10 w-10 "/>
                </div>
             
            </div>
            <span className="text-gray-600 dark:text-gray-400 text-xs mt-2">
                {shownData.windSpeed}
            </span>
        </div>
        <div className="flex flex-col items-center">
            <div className="relative">
                <div className="block relative">
                    <img alt="profil" src={hydrometer} className="mx-auto object-cover rounded-full h-10 w-10 "/>
                </div>
             
            </div>
            <span className="text-gray-600 dark:text-gray-400 text-xs mt-2">
                {shownData.humidity}
            </span>
        </div>
    </div>
</div>

    )
}
 export default MobileSideBar;